<template>
  <div id="app" class="menu">
    <mt-header fixed title="筑富协同办公平台"> <mt-button icon="back" slot="left" @click.native="goBack">返回</mt-button></mt-header>
    <div v-if="isLoading" class="back-loading">数据加载中...</div>
    <div
        id="content"
        class="content"
        style="background: none"
        v-else
        :style="{
        height: 'calc(100vh - 50px)',
        background: '#f6f6f6'
      }"
    >
      <div>
        <div class="menu-head">
          <img class="img-full" src="~@/assets/images/menu/index.png" />
        </div>
      </div>
      <div class="main_content" style="display: flex; flex-direction: column">
        <div
            class="subscribe"
        >
          <div class="sixthContent" style="justify-content: space-around">
            <div style="display: flex; align-items: flex-end"
                 @click="linkUrl('/procedure/addOfficialVehicles')">
              <img
                  class="icon"
                  :src="require(`@/assets/login-index/indexICON72.png`)"
              />
              <div class="right">
                <div class="text">公务用车</div>
              </div>
            </div>
            <div class="line"></div>
            <div
                style="display: flex; align-items: flex-end"
                @click="linkUrl('/procedure/addHoliday')"
            >
              <img
                  class="icon"
                  :src="require(`@/assets/login-index/indexICON74.png`)"
              />
              <div class="right">
                <div class="text">请假申请</div>
              </div>
            </div>
          </div>
          <div class="sixthContent" style="justify-content: space-around" >
            <div style="display: flex; align-items: flex-end"
                 @click="linkUrl('/procedure/addOutSeal')">
              <img
                  class="icon"
                  :src="require(`@/assets/login-index/indexICON3.png`)"
              />
              <div class="right">
                <div class="text">印章外出</div>
              </div>
            </div>
            <div class="line"></div>
            <div
                style="display: flex; align-items: flex-end"
                @click="linkUrl('/procedure/addUseSeal')"
            >
              <img
                  class="icon"
                  :src="require(`@/assets/login-index/indexICON5.png`)"
              />
              <div class="right">
                <div class="text">用印申请</div>
              </div>
            </div>
          </div>
          <div class="sixthContent" style="justify-content: space-around" >
            <div
                style="display: flex; align-items: flex-end"
                @click="linkUrl('/procedure/apppurchased')"
            >
              <img
                  class="icon"
                  :src="require(`@/assets/login-index/indexICON8.png`)"
              />
              <div class="right">
                <div class="text">物品采购</div>
              </div>
            </div>
            <div class="line"></div>
            <div style="display: flex; align-items: flex-end"
                 @click="linkUrl('/procedure/appreceived')">
              <img
                  class="icon"
                  :src="require(`@/assets/login-index/indexICON11.png`)"
              />
              <div class="right">
                <div class="text">物品领用</div>
              </div>
            </div>
          </div>
          <div class="sixthContent" style="justify-content: space-around" >
            <div style="display: flex; align-items: flex-end"
                 @click="linkUrl('/procedure/addOverTime')">
              <img
                  class="icon"
                  :src="require(`@/assets/login-index/indexICON74.png`)"
              />
              <div class="right">
                <div class="text">加班/调休申请</div>
              </div>
            </div>
          <div class="line" v-if="roleId==6"></div>
            <div v-if="roleId==6"
                style="display: flex; align-items: flex-end"
                @click="linkUrl('/procedure/addRepairVehicle')"
            >
              <img
                  class="icon"
                  :src="require(`@/assets/login-index/indexICON71.png`)"
              />
              <div class="right">
                <div class="text">车辆维修申请</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Toast} from "mint-ui";
import {getLocalData} from "@/utils/sessionData";
import axios from "axios";
import request from "@/utils/keyCloakRequest";

export default {
  data() {
    return {
      isLoading: false,
      roleId: null,
    };
  },
  computed: {
  },
  async created() {
    this.userInfo = JSON.parse(getLocalData("userInfo"))
    this.roleId = this.userInfo.role.roleId
    this.userId = this.userInfo.userId
  },
  watch: {
  },
  methods: {
    goBack() {
      this.$router.push("/home");
    },
    linkUrl(url, params) {
      this.$router.push({
        path: url,
        query: params
      });
    }
  },
};
</script>
